{
	"LockedOut": "User Locked Out:",
	"PromptTos": "Prompt Terms of Service:",
	"NotifyPasswordChange": "Notify Password Change:",
	"UpdateInterval": "Report Update Interval:",
	"UpdateIntervalCharacter": "s",
	"UpdateIntervalValidation": "Report update interval has a maximum of 180 seconds",
	"MediaPlayer": "Disable Media Player Plugin-Ins:",
	"DragAndDrop": "Disabled Drag & Drop Features:",
	"JavascriptOutput": "JavaScript Audit Output:",
	"AutoValue": "[Auto]",
	"NAME": "SettingsLanguage",
	"SettingsLanguage_ServiceNotification": "Service Notification:",
	"SettingsLanguage_AuthNotifications": "Auth Notification:",
	"SettingsLanguage_NewDeviceNotifications": "Provisioning Notifications:",
	"SettingsLanguage_AuthNotifications_Help": "Enabling Auth Notifications means the administrator will receive a email on the successful authorisation of an MS Teams Telephony Server",
	"SettingsLanguage_NewDeviceNotifications_Help": "Enabling Provisioning Notifications means the administrator will receive a email when a new device is added or the integration mode is changed on an MS Teams Instance",
	"SettingsLanguage_ConcurrentSignins": "Concurrent Sign-Ins Permitted:",
	"SettingsLanguage_AdvancedTitle": "Advanced Diagnostics"
}